import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu", "caret"];

  toggle() {
    this.menuTarget.classList.toggle('hidden');
    this.caretTarget.classList.toggle('caret-up');
  }
}